import React from "react";
import { History } from "lucide-react";

export const RedemptionHistory = ({ redemptions, textColor = "#16243b", experience = false }) => {
  if (!redemptions || redemptions.length === 0) {
    return <p className="text-xs text-[#8a97a8] mt-4" data-testid="redemption-history-empty">{experience ? "Not used yet." : "No redemptions yet — the full balance is available."}</p>;
  }
  return (
    <div className="mt-5" data-testid="redemption-history">
      <p className="text-sm font-semibold flex items-center gap-1.5 mb-2" style={{ color: textColor }}><History size={15} /> Redemption history</p>
      <ul className="divide-y divide-gray-100 rounded-xl border border-gray-100 bg-white">
        {redemptions.map((r, i) => (
          <li key={i} className="flex items-center justify-between px-4 py-2.5 text-sm" data-testid={`redemption-row-${i}`}>
            <span className="text-[#5a6b80]">
              {new Date(r.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}
              <span className="text-xs text-[#8a97a8] ml-2">{r.type === "full" ? "Full redemption" : "Partial"}</span>
            </span>
            <span className="font-semibold" style={{ color: textColor }}>−£{Number(r.amount).toFixed(2)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
